import { Box, Input } from '@nimbus-ds/components';
import './TaskInputCard.scss';

interface TaskInputCardProps {
  freeText: string;
  onChange: (value: string) => void;
  label: string;
  placeholder: string;
  hasError?: boolean;
  isRevamp?: boolean;
}

export function TaskInputCard({
  freeText,
  onChange,
  label,
  placeholder,
  hasError = false,
  isRevamp = false,
}: Readonly<TaskInputCardProps>) {
  const boxShadow = isRevamp || hasError ? '0' : '2';
  return (
    <Box
      data-style="stratus--card-box"
      borderStyle="solid"
      borderWidth="1"
      borderColor={hasError ? 'danger-interactive' : 'transparent'}
      borderRadius="2"
      data-variant={hasError && isRevamp ? 'light-danger' : undefined}
      boxShadow={boxShadow}
    >
      <div className="stratus--task-input-card">
        <Input
          append={label}
          appendPosition="start"
          value={freeText}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </Box>
  );
}
